import React, { Dispatch, SetStateAction } from "react";

type Props = {
  Active: () => void;
  setCancel?: Dispatch<SetStateAction<string | undefined>>;
};

const WidthDrawPopup = ({ Active, setCancel }: Props) => {
  return (
    <div className="remove-popup">
      <div className="title">정말 PQ와 이별하실건가요?</div>
      <div className="sub">당신과 함께 해서 정말 행복했습니다.</div>
      <div className="btn-wrapper">
        <button
          className="active-btn"
          onClick={() => {
            if (setCancel) {
              setCancel(undefined);
            }
          }}
        >
          PQ와 함께하기
        </button>
        <button
          className="deactive-btn"
          onClick={() => {
            Active();
          }}
        >
          PQ와 이별하기
        </button>
      </div>
    </div>
  );
};

export default WidthDrawPopup;
